import { render } from "./ReviewAttachmentRow.vue?vue&type=template&id=4afe96f3&ts=true"
import script from "./ReviewAttachmentRow.ts?vue&type=script&lang=ts&external"
export * from "./ReviewAttachmentRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__